export default class Group
{
    constructor(id, name)
    {
        this.id = id;
        this.name = name;
    }

    getId()
    {
        return this.id;
    }

    getName()
    {
        return this.name;
    }

    clone()
    {
        return new Group(this.id, this.name);
    }
}



// WEBPACK FOOTER //
// ./web/js/store/Group.js